const value = Object.freeze({
  UnSet: 0,
  EscuelaRevisionDePEI: 1,
  DashboardInventarioAT: 29,
  DashboardInventarioBooks: 31
});
export default value;
